/* eslint-disable require-jsdoc */
function getOption(optsObj, optionStr, defaultOpt) {
  return optsObj.hasOwnProperty.call(optsObj, optionStr) ?
    optsObj[optionStr] :
    defaultOpt;
}
function getMenuOptions(options) {
  const defaultOpts = {
    genre: false,
    day: false,
    sort: false,
    search: false,
  };
  const menuOptions = getOption(options, 'menuOptions', defaultOpts);
  return checkMenuOptions(menuOptions);
}
function checkMenuOptions(options) {
  return {
    search: getOption(options, 'search', false),
    eventPopUp: getOption(options, 'eventPopUp', false),
  };
}
function getLocOptions(options) {
  const defaultOpts = {
    lat: 42.35866,
    lng: -71.05674,
  };
  const locOptions = getOption(options, 'loc', defaultOpts);
  return checkLocOptions(locOptions);
}
function checkLocOptions(options) {
  return {
    lat: getOption(options, 'lat', 0.0),
    lng: getOption(options, 'lng', 0.0),
  };
}
export {getOption, getMenuOptions, getLocOptions};
